import { jsx as _jsx } from "react/jsx-runtime";

/* hs-eslint ignored failing-rules */

/* eslint-disable react-hooks/exhaustive-deps */
import FormattedMessage from 'I18n/components/FormattedMessage';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import MarketingContactsSidegradeButton from 'pricing-pages-ui/components/marketing-contacts-sidegrade/MarketingContactsSidegradeButton';
import { shouldShowEligibilityFlowSelector } from 'pricing-pages-ui/selectors/MarketingContactsSelectors';
import { hasProductVersionOrNewerInProductInventorySelector, highestProductLevelFromProductInventorySelector, productVersionFromProductInventorySelector } from 'pricing-pages-ui/selectors/ProductInventorySelectors';
import { crmSuiteProductLevelSelector, productForSkuIdSelector, productSelector, productVersionSelector, skuSelector } from 'pricing-pages-ui/selectors/ProductsSelectors';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { MARKETING } from 'self-service-api/constants/ProductLines';
import { MARKETING_HUB_ENTERPRISE, MARKETING_HUB_PROFESSIONAL, MARKETING_HUB_STARTER } from 'self-service-api/constants/ProductNames';
import { PRODUCT_VERSION, QUANTITY_PACK } from 'self-service-api/constants/SkuTypes';
import VersionNumbers from 'self-service-api/constants/VersionNumbers';
import UIAdminOnlyWrapper from 'ui-addon-upgrades/decorators/UIAdminOnlyWrapper';
import ContactsConfirmationRedirectButton from 'ui-addon-upgrades/_core/additionalContacts/ContactsConfirmationRedirectButton';
import { REQUEST_MC_WRITE } from 'ui-addon-upgrades/_core/common/constants/AdminModalTypes';
import { MARKETABLE_CONTACTS_WRITE } from 'ui-addon-upgrades/_core/common/constants/AdminTypes';
import * as PurchaseMotionTypes from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import { Metrics } from 'pricing-pages-ui/utils/metrics';

const isMarketingContactsSidegradeSelector = (state, {
  apiName,
  checkoutMarketingProductLevel,
  checkoutMarketingVersionNumber
}) => {
  const {
    productLevel
  } = productSelector(state, {
    apiName
  }); // Is this purchase motion the same level as the marketing item in the checkout config

  const isCheckingoutWithSpecifiedLevel = checkoutMarketingProductLevel === productLevel; // Is this purchase motion the same level as the highest marketing level owned by this portal

  const isOwnedProductLevelSpecifiedLevel = highestProductLevelFromProductInventorySelector(state, {
    productLine: MARKETING
  }) === productLevel; // Is the marketing item in the checkout config greater than or equal to the first marketing contacts version

  const isMarketingContacts = checkoutMarketingVersionNumber >= // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  VersionNumbers[apiName].MARKETING_CONTACTS; // Does this portal own the marketing contacts version of this product

  const ownsMarketingContacts = hasProductVersionOrNewerInProductInventorySelector(state, {
    apiName,
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    versionNumber: VersionNumbers[apiName].MARKETING_CONTACTS
  });
  return isCheckingoutWithSpecifiedLevel && isMarketingContacts && isOwnedProductLevelSpecifiedLevel && !ownsMarketingContacts;
};

const MarketingPurchaseMotionButtonWrapper = props => {
  const {
    className,
    style = {},
    use,
    productConfigurations = [],
    trackingSource,
    upgradeData,
    nonMerchandiseIdIdentifier,
    purchaseMotions,
    level,
    queryParamTerm,
    filterOwnedMarketingProducts = true
  } = props;
  const history = useHistory();
  const purchaseMotion = purchaseMotions[level - 1];
  const skuIds = productConfigurations.map(({
    skuId
  }) => skuId);
  const checkoutMarketingSkuId = useSelector(state => skuIds.find(skuId => {
    const product = productForSkuIdSelector(state, {
      skuId
    });
    return product.productLine === MARKETING && product.productLevel;
  }));
  const additionalUnitQuantity = useSelector(state => {
    const quantityPackConfig = productConfigurations.find(({
      skuId
    }) => {
      const {
        productVersionSkuId,
        skuType
      } = skuSelector(state, {
        skuId
      });
      return skuType === QUANTITY_PACK && productVersionSkuId === checkoutMarketingSkuId;
    });
    if (!quantityPackConfig) return 0;
    const {
      quantityUnit: {
        includedWithQuantityPack
      }
    } = skuSelector(state, {
      skuId: quantityPackConfig.skuId
    });
    return quantityPackConfig.quantity * includedWithQuantityPack;
  });

  if (!checkoutMarketingSkuId) {
    throw new Error('productConfigurations does not contain a marketing product');
  }

  const {
    id: checkoutMarketingProductId,
    productLevel: checkoutMarketingProductLevel
  } = useSelector(state => productForSkuIdSelector(state, {
    skuId: checkoutMarketingSkuId
  }));
  const {
    versionNumber: checkoutMarketingVersionNumber
  } = useSelector(state => productVersionSelector(state, {
    skuId: checkoutMarketingSkuId
  }));
  const ownedMarketingSkuId = useSelector(state => {
    const productVersion = productVersionFromProductInventorySelector(state, {
      productAttributeFilters: {
        productId: checkoutMarketingProductId
      }
    });
    return productVersion && productVersion.skuId;
  });
  const ownsMarketingProductVersion = useSelector(state => {
    const {
      skuId: checkoutProductVersionSkuId
    } = productVersionSelector(state, {
      skuId: checkoutMarketingSkuId
    });
    return checkoutProductVersionSkuId === ownedMarketingSkuId;
  });
  const isCrmSuite = useSelector(state => crmSuiteProductLevelSelector(state, {
    skuIds
  }) === checkoutMarketingProductLevel);
  const shouldShowEligibilityFlow = useSelector(shouldShowEligibilityFlowSelector);
  const apiName = useSelector(state => {
    const foundSkuId = skuIds.filter(skuId => productForSkuIdSelector(state, {
      skuId
    }).productLine === MARKETING).find(skuId => {
      const {
        skuType,
        productVersionSkuId
      } = skuSelector(state, {
        skuId
      });

      if (skuType === QUANTITY_PACK) {
        return productVersionSkuId === ownedMarketingSkuId;
      } else if (skuType === PRODUCT_VERSION) {
        return isCrmSuite || (filterOwnedMarketingProducts ? skuId !== ownedMarketingSkuId : true);
      }

      return false;
    });

    if (!foundSkuId) {
      throw new Error(`Couldn't find a marketing SKU id in productConfigurations`);
    }

    const {
      skuId: productVersionSkuId
    } = productVersionSelector(state, {
      skuId: foundSkuId
    });
    const product = productVersionSkuId && productForSkuIdSelector(state, {
      skuId: productVersionSkuId
    });
    return product && product.apiName;
  });
  const apiNames = useSelector(state => skuIds.map(skuId => productForSkuIdSelector(state, {
    skuId
  }).apiName));
  const ownsProduct = !isCrmSuite && ownsMarketingProductVersion;
  const isSidegradeMarketingStarterMC = useSelector(state => isMarketingContactsSidegradeSelector(state, {
    apiName: MARKETING_HUB_STARTER,
    checkoutMarketingVersionNumber,
    checkoutMarketingProductLevel
  }));
  const isSidegradeMarketingProMC = useSelector(state => isMarketingContactsSidegradeSelector(state, {
    apiName: MARKETING_HUB_PROFESSIONAL,
    checkoutMarketingVersionNumber,
    checkoutMarketingProductLevel
  }));
  const isSidegradeMarketingEntMC = useSelector(state => isMarketingContactsSidegradeSelector(state, {
    apiName: MARKETING_HUB_ENTERPRISE,
    checkoutMarketingVersionNumber,
    checkoutMarketingProductLevel
  }));

  const touchlessContactsProductOnClick = () => {
    if (ownedMarketingSkuId) {
      getUsageTracker().track('buyAdditionalContacts', {
        trackingSource,
        productNames: apiNames,
        skuIds,
        additionalUnitQuantity
      });
    }

    const screen = window.location.pathname.split('/').pop();
    getUsageTracker().track('confirmContactsRedirectButtonInteraction', {
      action: 'clicked',
      trackingSource,
      productNames: apiNames,
      skuIds,
      additionalUnitQuantity,
      screen
    });

    if (!ownsProduct && !(isSidegradeMarketingStarterMC || isSidegradeMarketingProMC) && purchaseMotion === PurchaseMotionTypes.BUY_TOUCHLESS) {
      Metrics.counter('buy-now-clicked').increment();
    }

    history.push(`/confirm-contacts${upgradeData.source ? `?upgradeSource=${upgradeData.source}` : ''}`, {
      productConfigurations,
      queryParamTerm
    });
  };

  useEffect(() => {
    const screen = window.location.pathname.split('/').pop();
    getUsageTracker().track('confirmContactsRedirectButtonInteraction', {
      action: 'viewed',
      trackingSource,
      isSidegrade: isSidegradeMarketingStarterMC || isSidegradeMarketingProMC || isSidegradeMarketingEntMC,
      screen
    });
  }, []);

  if (purchaseMotion === PurchaseMotionTypes.BUY_ADDITIONAL_CONTACTS) {
    if (isSidegradeMarketingStarterMC || isSidegradeMarketingProMC || isSidegradeMarketingEntMC) {
      return /*#__PURE__*/_jsx(MarketingContactsSidegradeButton, Object.assign({}, props, {
        skuId: checkoutMarketingSkuId
      }));
    }
  }

  const ccButton = /*#__PURE__*/_jsx(ContactsConfirmationRedirectButton, {
    additionalUnitQuantity: additionalUnitQuantity,
    className: className,
    style: style,
    ownsProduct: ownsProduct,
    onClick: touchlessContactsProductOnClick,
    trackingSource: trackingSource,
    use: use,
    seleniumId: nonMerchandiseIdIdentifier || apiName,
    upgradeData: upgradeData,
    children: (isSidegradeMarketingStarterMC || isSidegradeMarketingProMC) && /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketingContactsBeta.switchToMarketingContacts"
    })
  });

  return shouldShowEligibilityFlow ? /*#__PURE__*/_jsx(UIAdminOnlyWrapper, {
    adminType: MARKETABLE_CONTACTS_WRITE,
    modalType: REQUEST_MC_WRITE,
    upgradeData: upgradeData,
    children: ccButton
  }) : ccButton;
};

export default MarketingPurchaseMotionButtonWrapper;